var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"state q-pa-lg"},[_c('pre',[_vm._v("    "+_vm._s(_vm._f("json")(_vm.store.state))+"\n  ")]),_c('ws-back')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }